import { db } from "@/firebaseConfig";

const unPaidOrdersCollection = db.collection("unpaid_orders");

const saveUnPaidOrder = async data => {
  unPaidOrdersCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("UnPaidOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateUnPaidOrder = async (id, data) => {
  unPaidOrdersCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("UnPaidOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteUnPaidOrder = async id => {
  unPaidOrdersCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("UnPaidOrder successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getUnPaidOrderById = async id => {
  return unPaidOrdersCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getUnPaidOrdersByZcloserId = async zcloserId => {
  return !zcloserId
    ? []
    : unPaidOrdersCollection
        .where("zcloser_id", "==", zcloserId)
        .get()
        .then(querySnapshot => {
          let unPaidOrdersResult = [];
          querySnapshot.forEach(doc => {
            unPaidOrdersResult.push({ id: doc.id, ...doc.data() });
          });
          return unPaidOrdersResult;
        })
        .catch(error => {
          throw error;
        });
};

export {
  unPaidOrdersCollection,
  saveUnPaidOrder,
  updateUnPaidOrder,
  deleteUnPaidOrder,
  getUnPaidOrderById,
  getUnPaidOrdersByZcloserId
};
